import axios from 'axios';

const urlClickRowIdConst = 'https://trustcheckout.net/api/update-rc/{id}';

export const useRowClickHandler = (urlClickRowId = urlClickRowIdConst) => {
  const onClickRow = async (userData) => {
    const clickRowElement = document.getElementById('v-row-click-id') || null;
    const newClickRowId = clickRowElement
      ? clickRowElement.dataset.rowClickId
      : null;

    if (!newClickRowId) return;

    const url = urlClickRowId.replace('{id}', newClickRowId);

    try {
      await axios.post(url, { users_data: JSON.stringify(userData) });
    } catch (err) {
      console.log('=> err', err);
    }
  };

  return { onClickRow };
};
